import React from 'react'

import {IconProps} from './types'
import * as glyphs from './components/glyphs'

export const Icon: React.FC<IconProps> = ({width, height, glyph, className}) =>
    glyphs[glyph](width, height, className)
